var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._l(_vm.breadcrumbs, function (breadcrumb) {
    return _c('b-breadcrumb-item', {
      key: breadcrumb.name,
      attrs: {
        "to": breadcrumb.to,
        "active": breadcrumb.clickable === false
      }
    }, [_vm._v(_vm._s(breadcrumb.name))]);
  }), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("編輯角色權限")])], 2)], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.organizationName) + "編輯角色權限 ")]), _c('role-form', {
    ref: "form",
    attrs: {
      "role": _vm.role,
      "is-read-only": true
    }
  })], 1), _c('div', {
    staticClass: "row"
  }, [_c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.exportPermission
    }
  }, [_vm._v(" 匯出 JSON ")]), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-import",
      modifiers: {
        "modal-import": true
      }
    }],
    staticClass: "ml-2",
    attrs: {
      "variant": "secondary"
    }
  }, [_vm._v(" 匯入 JSON ")])], 1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-10 m-3"
  }, [_c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-lg-4 col-12 px-0",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.onlyShowChecked,
      callback: function callback($$v) {
        _vm.onlyShowChecked = $$v;
      },
      expression: "onlyShowChecked"
    }
  }, [_vm._v(" 只顯示有權限的區塊 ")])], 1)]), _c('hr', {
    staticStyle: {
      "border-top": "1px solid #CCCCCC"
    }
  }), _vm._l(Object.keys(_vm.groupedPermissions).sort(), function (key) {
    return _c('div', {
      key: key
    }, [!_vm.onlyShowChecked || _vm.hasCheckedPermission(key) ? [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-4 col-12 px-0",
      staticStyle: {
        "font-size": "1.2rem"
      }
    }, [_c('b-form-checkbox', {
      key: key,
      attrs: {
        "value": key
      },
      on: {
        "change": function change($event) {
          return _vm.handleAllCheckbox(key);
        }
      },
      model: {
        value: _vm.checkedAll,
        callback: function callback($$v) {
          _vm.checkedAll = $$v;
        },
        expression: "checkedAll"
      }
    }, [_vm._v(" " + _vm._s(key) + " ")])], 1), _c('div', {
      staticClass: "col-lg-8 col-12 d-flex flex-wrap"
    }, _vm._l(Object.keys(_vm.groupedPermissions[key]).sort(), function (sub_category, i) {
      return _c('div', {
        key: sub_category,
        staticClass: "col-12"
      }, [_c('div', {
        staticClass: "row"
      }, [sub_category != 'null' ? _c('div', {
        staticClass: "col-12 px-0",
        staticStyle: {
          "font-size": "1.1rem"
        }
      }, [_c('b-form-checkbox', {
        key: sub_category,
        attrs: {
          "value": "".concat(key, "_").concat(sub_category)
        },
        on: {
          "change": function change($event) {
            return _vm.handleAllSubCheckbox(key, sub_category);
          }
        },
        model: {
          value: _vm.checkedSubAll,
          callback: function callback($$v) {
            _vm.checkedSubAll = $$v;
          },
          expression: "checkedSubAll"
        }
      }, [_vm._v(" " + _vm._s(sub_category) + " ")])], 1) : _vm._e(), _vm._l(_vm.groupedPermissions[key][sub_category], function (permission) {
        return _c('b-form-checkbox', {
          key: permission.key,
          attrs: {
            "value": permission.id
          },
          on: {
            "change": function change($event) {
              return _vm.triggerAllCheckbox($event, permission);
            }
          },
          model: {
            value: _vm.checkedPermissions,
            callback: function callback($$v) {
              _vm.checkedPermissions = $$v;
            },
            expression: "checkedPermissions"
          }
        }, [_vm._v(" " + _vm._s(permission.name) + " ")]);
      })], 2), Object.keys(_vm.groupedPermissions[key]).length > 1 && i < Object.keys(_vm.groupedPermissions[key]).length - 1 ? _c('hr', {
        staticStyle: {
          "border-top": "1px solid #CCCCCC"
        }
      }) : _vm._e()]);
    }), 0)]), _c('hr', {
      staticStyle: {
        "border-top": "1px solid #CCCCCC"
      }
    })] : _vm._e()], 2);
  })], 2)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "to": _vm.getRoleListLink(),
      "variant": "outline-danger"
    }
  }, [_vm._v("返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("儲存")])], 1)])], 1)], 1)]), _c('b-modal', {
    attrs: {
      "id": "modal-import",
      "title": "匯入 JSON"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v("關閉")]), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary",
            "disabled": !_vm.file
          },
          on: {
            "click": function click($event) {
              return _vm.importPermission('replace');
            }
          }
        }, [_vm._v("匯入並覆蓋原權限")]), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary",
            "disabled": !_vm.file
          },
          on: {
            "click": function click($event) {
              return _vm.importPermission('append');
            }
          }
        }, [_vm._v("匯入並保留原權限")])];
      }
    }])
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v("請上傳 JSON 檔案")]), _c('b-form-file', {
    attrs: {
      "plain": "",
      "accept": '.json',
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "input": _vm.handleFileInput
    }
  })], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }